import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import WapiService from 'wanderu-service-wapi';

import * as actions from './actions';
import * as selectors from './selectors';

const logger = Logger.getLogger('wanderu-ducks-browser-meta');

function fetchBrowserMeta(userAgent = '') {
    return async (dispatch, getState) => {
        const isFetching = selectors.selectBrowserMetaFetching(getState());
        const hasData = !!selectors.selectUserLocation(getState());

        if (isFetching || hasData) {
            return;
        }

        dispatch(actions.setBrowserUserAgent(userAgent));
        dispatch(actions.fetchingBrowserMeta());

        let result;
        let meta;
        let error;
        try {
            const response = await WapiService.getWithoutAuth('ping.json');

            result = response.result;
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetchBrowserMeta', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.setBrowserMeta(result, meta, error));
        }
    };
}

function clearBrowserMeta() {
    return actions.clearBrowserMeta();
}

export {
    clearBrowserMeta,
    fetchBrowserMeta,
};
